import React, { useState, useEffect, useMemo } from "react";
import { FaCartPlus } from "@react-icons/all-files/fa/FaCartPlus";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";
import { CiStar } from "react-icons/ci";
import { Button } from "@chakra-ui/react";
import { ChevronsRight, ChevronsLeft, Loader } from "lucide-react";
import Shoploader from '../loader/Shoploader';
import { FaArrowRightLong } from "react-icons/fa6";
import breaks from "../../../../../src/assets/image/brakes.webp";
import CheckboxSelect from "../utils/customComponent/CheckboxSelect";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";
export default function PartNumberSearch() {
    const [loading, setLoading] = useState(false);
// Sample options
const options = [
    { value: 'option1', label: 'Option 1' },
    { value: 'option2', label: 'Option 2' },
    { value: 'option3', label: 'Option 3' },
];
    return (
        <div className='mt-[80px]'>
            <div className="flex lg:pt-10 md:pt-10  justify-center">
                <div className="container w-full px-2">
                    <div className="flex flex-col lg:px-[5.4%] ">
                        {/* Search bar and dropdown */}
                        <div className="mb-6 card shadow lg:p-4 md:p-4 p-2">
                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 gap-3 mx-2">

                                <div className="relative w-full">
                                    <input
                                        type="text"
                                        placeholder="Search Part Number"
                                        className="w-full px-4 py-2 border rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>

                                <div className="flex-cols gap-2 lg:flex md:flex">
                                    <CheckboxSelect options={options}/>
                                    <button className="bg-orange-500 rounded px-3 py-1.5  text-white font-bold lg:w-[300px] md:w-[300px] w-full mt-[10px] lg:mt-0 md:mt-0 "
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            {loading ? (
                                <div className="relative w-full h-[300px] ">
                                    <Shoploader />
                                </div>
                            ) : (
                                <div className=" flex flex-col items-center lg:px-[50px] gap-3 ">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-1  justify-center lg:w-[83vw] md:w-[86vw] w-[93vw] ">
                                        {/* Static product card 1 */}
                                        <div className="product-card flex border-2 min-h-10 shadow-lg rounded-md hover:border-blue-400 hover:scale-[102.5%] transition-all duration-300 ease-in-out lg:flex-row md:flex-row flex-col bg-white m-1">
                                            <div className="lg:w-[20vw] md:w-[20vw] w-full">
                                                {/* <div className="flex justify-between items-start">
                                                    <div className="flex space-x-1">
                                                        <span className="text-xs font-bold px-2 py-1 rounded bg-yellow-500 text-white">Sale</span>
                                                        <span className="text-xs font-bold px-2 py-1 rounded bg-blue-900 text-white">Popular</span>
                                                    </div>
                                                    <FaHeart size="25px" className="heart-icon cursor-pointer z-1 stroke-2 text-blue fill-blue" />
                                                </div> */}
                                                <img
                                                    src={breaks}
                                                    alt="Product 1"
                                                    className="w-full lg:h-[25vh] md:h-[20vh] h-[26vh] object-contain p-2 hover:scale-90 transition-all duration-300 ease-in-out cursor-pointer rounded-t-md"
                                                />
                                                <p className="font-semibold min-h-10 truncate px-2 lg:text-base cursor-pointer text-2xl text-start overflow-hidden mb-0">
                                                    Product Type 1
                                                </p>
                                                <div className="flex items-center mt-1 y-2 mx-2">
                                                    <div className="flex space-x-1 -mt-3">
                                                        {[...Array(5)].map((_, i) => (
                                                            <CiStar key={i} className="text-gray-400" />
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-between mx-2 mb-2 space-y-0">
                                                    <div className="text-red-600 font-bold">$123.45</div>
                                                </div>
                                            </div>
                                            <div className="lg:min-h-[35vh] p-2 overflow-hidden mt-2 lg:w-[20vw] md:w-[20vw] w-full flex flex-col mb-2">
                                                <p className="mb-[1px]"><span className="font-semibold">Supplier :</span> Supplier A</p>
                                                <p className="mb-1"><span className="font-semibold">Location :</span> Location A</p>
                                                <p className="mb-1"><span className="font-semibold">Brand :</span> Brand A</p>
                                                <p className="mb-1"><span className="font-semibold">Part Number :</span> 12345</p>
                                                <p className="mb-1"><span className="font-semibold">Part Type :</span> Type A</p>
                                                <div className="flex lg:h-full md:h-full h-full justify-start items-end ">
                                                    <button
                                                        className="text-white bg-blue-900 lg:p-2 md:px-[0.2rem] md:py-[0.5rem] p-[0.65rem] lg:w-8/12 md:w-full w-7/12 rounded-lg font-bold flex items-center lg:text-sm md:text-sm hover:scale-90 transition-all duration-300 ease-in-out"
                                                    >
                                                        <FaCartPlus size={"19px"} className="ms-0 me-2" />
                                                        Add To Cart
                                                        <FaLongArrowAltRight size={"17px"} className="mx-2" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Static product card 2 - same structure but different data */}
                                        <div className="product-card flex border-2 min-h-10 shadow-lg rounded-md hover:border-blue-400 hover:scale-[102.5%] transition-all duration-300 ease-in-out lg:flex-row md:flex-row flex-col bg-white m-1">
                                            <div className="lg:w-[20vw] md:w-[20vw] w-full">
                                                {/* <div className="flex justify-between items-start">
                                                    <div className="flex space-x-1">
                                                        <span className="text-xs font-bold px-2 py-1 rounded bg-green-500 text-white">New</span>
                                                    </div>
                                                    <FaHeart size="25px" className="heart-icon cursor-pointer z-1 stroke-2 text-blue fill-blue" />
                                                </div> */}
                                                <img
                                                    src={breaks}
                                                    alt="Product 2"
                                                    className="w-full lg:h-[25vh] md:h-[20vh] h-[26vh] object-contain p-2 hover:scale-90 transition-all duration-300 ease-in-out cursor-pointer rounded-t-md"
                                                />
                                                <p className="font-semibold min-h-10 truncate px-2 lg:text-base cursor-pointer text-2xl text-start overflow-hidden mb-0">
                                                    Product Type 2
                                                </p>
                                                <div className="flex items-center mt-1 y-2 mx-2">
                                                    <div className="flex space-x-1 -mt-3">
                                                        {[...Array(5)].map((_, i) => (
                                                            <CiStar key={i} className="text-gray-400" />
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-between mx-2 mb-2 space-y-0">
                                                    <div className="text-red-600 font-bold">$456.78</div>
                                                </div>
                                            </div>
                                            <div className="lg:min-h-[35vh] p-2 overflow-hidden mt-2 lg:w-[20vw] md:w-[20vw] w-full flex flex-col mb-2">
                                                <p className="mb-[1px]"><span className="font-semibold">Supplier :</span> Supplier B</p>
                                                <p className="mb-1"><span className="font-semibold">Location :</span> Location B</p>
                                                <p className="mb-1"><span className="font-semibold">Brand :</span> Brand B</p>
                                                <p className="mb-1"><span className="font-semibold">Part Number :</span> 67890</p>
                                                <p className="mb-1"><span className="font-semibold">Part Type :</span> Type B</p>
                                                <div className="flex lg:h-full md:h-full h-full justify-start items-end ">
                                                    <button
                                                        className="text-white bg-blue-900 lg:p-2 md:px-[0.2rem] md:py-[0.5rem] p-[0.65rem] lg:w-8/12 md:w-full w-7/12 rounded-lg font-bold flex items-center lg:text-sm md:text-sm hover:scale-90 transition-all duration-300 ease-in-out"
                                                    >
                                                        <FaCartPlus size={"19px"} className="ms-0 me-2" />
                                                        Add To Cart
                                                        <FaArrowRightLong size={"17px"} className="mx-2" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Add more static product cards if needed */}
                                    </div>

                                    {/* Pagination controls static - same structure */}
                                    <div className="flex justify-center items-center my-6 space-x-2">
                                        <button className="px-4 py-2 rounded-full text-gray-700 transition disabled:opacity-40 disabled:cursor-not-allowed">
                                            <ChevronsLeft size={20} />
                                        </button>

                                        <button className="w-9 h-9 rounded-full text-sm font-medium bg-orange-600 text-white transition">
                                            1
                                        </button>

                                        <button className="w-9 h-9 rounded-full text-sm font-medium bg-gray-100 hover:bg-orange-200 text-gray-800 transition">
                                            2
                                        </button>

                                        <button className="w-9 h-9 rounded-full text-sm font-medium bg-gray-100 hover:bg-orange-200 text-gray-800 transition">
                                            3
                                        </button>

                                        <span className="text-gray-500">...</span>

                                        <button className="w-9 h-9 rounded-full text-sm font-medium bg-gray-100 hover:bg-orange-200 text-gray-800 transition">
                                            5
                                        </button>

                                        <button className="px-4 py-2 rounded-full text-gray-700 transition disabled:opacity-40 disabled:cursor-not-allowed">
                                            <ChevronsRight size={20} />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
